import { useForm } from 'react-hook-form';
import { ClinicMasterProduct } from '../../../apis/clinic-master-products/types';
import Yup from '../../../utils/yup';
import { yupResolver } from '@hookform/resolvers/yup';

const useClinicMasterProductForm = (defaultValues?: ClinicMasterProduct | null) => {
  return useForm<ClinicMasterProduct>({
    defaultValues: defaultValues || emptyClinicMasterProduct,
    resolver: yupResolver(clinicMasterProductSchema),
  });
};

const emptyClinicMasterProduct: ClinicMasterProduct = {
  delivery_price: 0,
  pharmacy_fee_percentage: 0,
  master_medicine_id: '',
  clinic_id: '',
};

const clinicMasterProductSchema = Yup.object().shape({
  delivery_price: Yup.number().required().min(0),
  pharmacy_fee_percentage: Yup.number().nullable(),
  master_medicine_id: Yup.string().required(),
})

export default useClinicMasterProductForm;
